import * as React from "react";
import { DetailsList, IColumn, SelectionMode, Icon } from "office-ui-fabric-react";
import ValueEditor from "./ValueEditor";
import styled from "styled-components";
import * as G from "~/components/global.style";

export interface Props
{
    keyTitle: string;
    valueTitle: string;
    list: { [key: string]: string };
    onChange?: (key: string, value: string) => void;
    onRemove?: (key: string) => void;
}

interface State
{
    editingColumn?: number;
}

class KeyValueList extends React.Component<Props, State>
{
    private items: { key: string, value: string }[] = [];

    state: State = { };

    componentWillMount()
    {
        this.updateItems(this.props.list);
    }

    componentWillReceiveProps(nextProps: Props)
    {
        if (nextProps.list !== this.props.list)
        {
            this.updateItems(nextProps.list);
        }
    }

    private updateItems(list: Props["list"])
    {
        this.setState({ editingColumn: undefined });
        this.items = Object.keys(list)
            .map(key => ({ key, value: list[key] }));
    }

    private onColumnClick = (columnIndex: number) => 
    {
        this.setState({ editingColumn: columnIndex });
    }

    private onDimiss = () => this.setState({ editingColumn: undefined });

    private onChange = (rowIndex: number, newValue: string) => 
    {
        if (this.props.onChange && this.items.length > rowIndex)
        {
            const { key } = this.items[rowIndex];
            this.props.onChange(key, newValue);
        }
        this.setState({ editingColumn: undefined });
    }

    private valueColumnRenderer = (item?: { key: string, value: string}, index?: number, column?: IColumn) => 
    {
        const { editingColumn } = this.state;
        return (item && column && column.fieldName && typeof index !== "undefined") 
            ? (
                <ValueEditor 
                    rowIndex={index} 
                    value={item && item[column.fieldName]} 
                    onClick={this.onColumnClick}
                    onDismiss={this.onDimiss}
                    onChange={this.onChange}
                    isEditing={editingColumn === index} />
            ) : null;
    }

    private removeFieldRender  = (item?: { key: string, value: string}, index?: number, column?: IColumn) => 
    {
        if (item)
        {
            return <IconStyle>
                    <Icon style={{cursor: "pointer"}} onClick={this.removeField(item.key)} className="ms-Delete" iconName="Delete" />
                </IconStyle>;
        }
        
    }

    private removeField = (fieldName: string) => () =>
    {
        if (this.props.onRemove)
        {
            this.props.onRemove(fieldName);
        }
    }

    private getColumns()
    {
        const { keyTitle, valueTitle, onRemove } = this.props;
        const columns: IColumn[] = [
            {
                key: "key",
                fieldName: "key",
                minWidth: 100,
                maxWidth: 200,
                name: keyTitle
            },
            {
                key: "value",
                fieldName: "value",
                minWidth: 200,
                maxWidth: 400,
                name: valueTitle,
                onRender: this.valueColumnRenderer
            }
        ];
        if (onRemove)
        {
            columns.push({
                onRender: this.removeFieldRender,
                key: "remove",
                name: "",
                minWidth: 50,
                maxWidth: 50
            });
        }
        return columns;
    }
    
    render()
    {
        const columns = this.getColumns();

        return (
            <TranslationStyle>
                <DetailsList
                columns={columns}
                items={this.items}
                selectionMode={SelectionMode.none}
            /></TranslationStyle>
        );
    }
}

export default KeyValueList;

const IconStyle = styled.div`
    color: ${G.PrimaryColor};
    display: flex;
    cursor: pointer;
    a{
        color: ${G.PrimaryColor};
    }
    .ms-Delete{
        font-size: 18px;
        
    }

    [data-icon-name="SingleColumnEdit"]{
        margin-right: 5px;
    }
`;

const TranslationStyle = styled.div`
    .ms-DetailsRow-cell{
        font-size: 14px;
        margin: 6px 0;
        color: black;
        span
        {
            margin: 6px 0px;
        }
    }

`;


// WEBPACK FOOTER //
// ./src/components/translations/KeyValueList.tsx